export const workspace = {
  routes: [
    {
      path: "/workspace/library/agreement-type",
      component: () => import("../workspace-library-agreement-type-view"),
    },
  ],
};

export const management = {
  routes: [
  ],
};
